export default "__VITE_ASSET__BMolNpZP__"